import { gql } from '@apollo/client';
import { graphql } from '../../graphql';

export const getItemId = graphql(`
  query ItemId($id: ID!) {
    item(id: $id) {
      id
    }
  }
`);

export const getStaticCurrentItemPageData = gql`
  query StaticCurrentItemPage($id: ID!) {
    regions(cityId: 1) {
      id
      name
      latitude
      longitude
      slug
    }
    cities(filter: { scope: UNPOPULAR }, limit: 80) {
      id
      name
      slug
    }
    item(id: $id) {
      id
      address
      buildingTypeName
      contactTypeName
      category {
        id
        hasFloor
        hasLandArea
        name
        pluralName
        slug
        title
      }
      city {
        id
        name
        path
        slug
      }
      company {
        id
        name
        targetType
      }
      path
      longitude
      latitude
      location {
        fullName
        path
      }
      business {
        ... on Agency {
          id
          logoUrl
          name
          path
          schedule
          contactAddress
          latitude
          longitude
          city {
            name
          }
        }
        ... on Residence {
          id
          website
          logoUrl
          contactEmail
          path
          companyName
          apartments {
            area
          }
          deadline
          hasBillOfSale
          price {
            currency
            total {
              maximum
              minimum
            }
          }
          address
          lat
          lng
          schedule
          city {
            name
          }
        }
      }
      nearestLocations {
        ... on Location {
          path
          fullName
          id
        }
        ... on City {
          path
          name
          id
        }
      }
    }
  }
`;

export const getSsrCurrentItemPageData = gql`
  query SsrCurrentItemPage($id: ID!) {
    item(id: $id) {
      id
      breadcrumbs {
        name
        path
      }
      description
      leased
      rooms
      floor
      floors
      metaTags {
        name
        content
      }
      hasBillOfSale
      hasMortgage
      hasRepair
      state
      isExpiredManually
      isKapitalbankApplicable
      contactName
      business {
        ... on Agency {
          id
          itemsCount
          viewsCount
        }
      }
      updatedAt
      expiresAt
      views
      isFeatured
      isVipped
      landArea {
        units
        value
      }
      area {
        units
        value
      }
      price {
        currency
        value
      }
      paidDaily
      photos {
        full
        f660x496
        thumbnail
      }
    }
  }
`;

export const getCurrentItem = graphql(`
  query CurrentItem($id: ID!) {
    item(id: $id) {
      id
      address
      actions
      isReported
      isMine
      isBookmarked
      description
      leased
      rooms
      floor
      floors
      metaTags {
        name
        content
      }
      phones {
        ... on MaskedPhone {
          value
        }
        ... on Phone {
          value
        }
      }
      hasBillOfSale
      hasMortgage
      hasRepair
      state
      isExpiredManually
      isKapitalbankApplicable
      contactName
      contactTypeName
      buildingTypeName
      longitude
      latitude
      path
      paidServices {
        id
        options {
          id
          name
          price
          priceWithDiscount(paymentMethodId: "wallet")
        }
        paymentMethods {
          id
          balance
          name
          cardToken
          iconUrl
        }
        activeUntil
        title
        targetType
      }
      business {
        ... on Agency {
          id
          itemsCount
          logoUrl
          name
          path
          viewsCount
          schedule
          contactAddress
          latitude
          longitude
          city {
            name
          }
        }
        ... on Residence {
          id
          website
          logoUrl
          contactEmail
          path
          companyName
          apartments {
            area
          }
          deadline
          hasBillOfSale
          price {
            currency
            total {
              maximum
              minimum
            }
          }
          address
          lat
          lng
          schedule
          city {
            name
          }
        }
      }
      nearestLocations {
        ... on Location {
          path
          fullName
          id
        }
        ... on City {
          path
          name
          id
        }
      }
      updatedAt
      expiresAt
      views
      isFeatured
      isVipped
      rejectReason
      location {
        fullName
        path
      }
      landArea {
        units
        value
      }
      area {
        units
        value
      }
      price {
        currency
        value
      }
      paidDaily
      company {
        id
        name
        targetType
      }
      breadcrumbs {
        name
        path
      }
      category {
        id
        hasFloor
        hasLandArea
        name
        pluralName
        slug
        title
      }
      city {
        id
        name
        path
        slug
      }
      photos {
        full
        f660x496
        thumbnail
      }
    }
    flashMessages {
      type
      message
    }
  }
`);

export const getUserRelatedItem = graphql(`
  query UserRelatedItem($id: ID!) {
    item(id: $id) {
      id
      actions
      isReported
      isMine
      isBookmarked
      rejectReason
      paidServices {
        id
        options {
          id
          name
          price
          priceWithDiscount(paymentMethodId: "wallet")
        }
        paymentMethods {
          id
          balance
          name
          cardToken
          iconUrl
        }
        activeUntil
        title
        targetType
      }
      phones {
        ... on MaskedPhone {
          value
        }
        ... on Phone {
          value
        }
      }
      expiresAt
    }
  }
`);

export const getReportReasonsQuery = graphql(`
  query ReportReasons {
    reportReasons {
      id
      reason
    }
  }
`);
